<template>
  <div class="container">
    <div class="content">
      <div class="top-content" v-if="list.length < familyNum">
        <div class="top-btn-content" v-if="list.length < familyNum">
          <van-button class="btn" size="mini" plain @click="handleAdd">
            添加家属
          </van-button>
        </div>
      </div>
      <div class="main-content">
        <div class="main-items" v-for="(item, index) in list" :key="index">
          <div class="items-content">
            <div class="items-img-content">
              <img
                class="items-img"
                :src="item.photo ? `${apiUrl}/image?name=${item.photo}` : none"
                alt
              />
            </div>
            <div class="items-info-content">
              <div class="items-info-top">
                <div class="items-info-name">{{ item.name }}</div>
                <div class="items-info-feature" v-if="item.feature">掌纹</div>
              </div>
              <div class="items-info-phone">{{ item.phone }}</div>
            </div>
          </div>
          <div class="items-btn-content">
            <van-button
              class="btn"
              size="mini"
              plain
              style="
                background: #fff;
                color: #fa5050;
                margin-right: 12px;
                border-color: #fa5050;
              "
              @click="handleEdit(item)"
            >
              编辑
            </van-button>
            <van-button
              class="btn"
              size="mini"
              plain
              style="background: #fa5050; color: #fff; border-color: #fa5050"
              @click="handleDelete(item)"
            >
              删除
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/cancel.png';
import none from '@/assets/photo_none.png';
import store from '../../store';
import { Dialog, Toast } from 'vant';
import {
  getUserMemberList,
  removeUserMember,
  getUserSystemSetupAPI
} from '@/api/family.js';
export default {
  name: 'FamilyRecord',
  data() {
    return {
      cancel,
      none,
      apiUrl: process.env.VUE_APP_BASE_API,
      list: [],
      familyNum: null
    };
  },

  created() {
    this.getList();
    this.getUserSystemSetupFn();
  },

  methods: {
    toHome() {
      this.$router.push({ name: 'Center' });
    },

    async getUserSystemSetupFn() {
      const organizationId = JSON.parse(
        sessionStorage.getItem('personInfo')
      ).organizationId;
      const user = JSON.parse(sessionStorage.getItem('personInfo'));
      const res = await getUserSystemSetupAPI(organizationId);
      if (res.code === 0 && res.data !== null) {
        if (JSON.parse(res.data.setting) !== '{}') {
          this.familyNum = JSON.parse(res.data.setting).family_set.num;
        }
      }
    },

    async getList() {
      // featureFlag: 0 表示未上传， 1 表示已上传
      const userId = store.getters.userId;
      const res = await getUserMemberList(userId);
      if (res.code === 0) {
        this.list = res.data;
      }
    },

    handleEdit(item) {
      this.$router.push({ name: 'FamilyDetail', query: { id: item.id } });
    },

    handleDelete(item) {
      Dialog.confirm({
        title: '删除',
        message: '确定要删除该家属吗?'
      })
        .then(async () => {
          const res = await removeUserMember(item.id);
          if (res.code === 0) {
            Toast.success({ message: '删除成功' });
            this.getList();
          }
        })
        .catch(() => {
          return;
        });
    },

    handleAdd() {
      this.$router.push({ name: 'FamilyDetail' });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    .top-content {
      width: 100%;
      height: 60px;
      background: #f1f1f1;
      .top-btn-content {
        width: 100%;
        height: 60px;
        position: absolute;
        box-sizing: border-box;
        padding: 10px 16px 0;
        background: #f1f1f1;
        .btn {
          width: 100%;
          height: 45px;
          background: #fa5050;
          font-size: 18px;
          color: #fff;
          border-radius: 4px;
        }
      }
    }
    .main-content {
      flex: 1;
      overflow: auto;
      box-sizing: border-box;
      padding: 10px 16px 10px;
      .main-items {
        background: #fff;
        margin-bottom: 15px;
        border-radius: 8px;
        .items-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px #f7f7f7 solid;
          padding-bottom: 10px;
          box-sizing: border-box;
          padding: 16px;
          .items-img-content {
            width: 55px;
            height: 55px;
            border-radius: 50%;
            .items-img {
              width: 100%;
              height: 100%;
            }
          }
          .items-info-content {
            flex: 1;
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 60px;
            box-sizing: border-box;
            padding: 0 16px;
            .items-info-top {
              display: flex;
              flex-direction: row;
              align-items: center;
              .items-info-name {
                font-size: 18px;
                color: #333;
              }
              .items-info-feature {
                font-size: 12px;
                color: #fff;
                margin-left: 12px;
                background: #c7000b;
                height: 21px;
                width: 42px;
                text-align: center;
                line-height: 21px;
                border-radius: 4px;
              }
            }
            .items-info-phone {
              font-size: 15px;
              color: #666;
            }
          }
        }
        .items-btn-content {
          width: 100%;
          text-align: right;
          margin-top: 15px;
          box-sizing: border-box;
          padding: 0 16px 16px;
          .btn {
            width: 80px;
            height: 33px;
            font-size: 16px;
            box-sizing: border-box;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
